import path from "ramda/es/path";
import identity from "ramda/es/identity";
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import { createSelector } from 'reselect';
/**
 * get entire form from state
 *
 * @documented
 * @category Selector
 * @example
 *
 * 	getEntireForm(state)
 *
 */ export const getEntireForm = memoizeWithIdentity((formName)=>createSelector(path([
        formName
    ]), identity));
